import { Pipe, PipeTransform } from '@angular/core';
import { FormatService } from '@services/format.service';

@Pipe({
    name: 'formatFte'
})
export class FormatFtePipe implements PipeTransform {

    constructor(
        private formatSrv: FormatService
    ) { }

    transform(fte: number | string, args?: any): any {
        let value: number;
        if (typeof fte === 'string') {
            value = parseFloat(fte);
        } else {
            value = fte
        }
        return value > 0 ? this.formatSrv.precision(value,  2) : '-';
    }

}
